export const fmtMoney = (n) =>
  Number(n || 0).toLocaleString('en-AE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const MOVEMENT_LABELS = {
  new: ['New assignment', 'bg-emerald-50 text-emerald-700 border-emerald-200'],
  legacy: ['Assigned (no handover form)', 'bg-sky-50 text-sky-700 border-sky-200'],
  rider_change: ['Rider change (not counted)', 'bg-slate-100 text-slate-600 border-slate-200'],
  back_from_temporary: ['Back from temporary (not counted)', 'bg-slate-100 text-slate-600 border-slate-200'],
  temporary: ['Temporary / maintenance (not counted)', 'bg-amber-50 text-amber-700 border-amber-200'],
  returned: ['Permanent takeover', 'bg-orange-50 text-orange-700 border-orange-200'],
  transferred: ['Moved to other lessee', 'bg-rose-50 text-rose-700 border-rose-200'],
  no_matching_handover: ['Duplicate (not counted)', 'bg-slate-100 text-slate-600 border-slate-200'],
};

export const POSSESSION_STATUS = {
  'held all month': ['Held all month', 'bg-slate-50 text-slate-700 border-slate-200'],
  'handed over this month': ['New this month', 'bg-emerald-50 text-emerald-700 border-emerald-200'],
  'permanently taken over / moved this month': ['Taken over this month', 'bg-orange-50 text-orange-700 border-orange-200'],
  'seen in battery swaps (no handover on file)': ['Swaps only - no handover form', 'bg-amber-50 text-amber-800 border-amber-300'],
};

export const movementLabel = (m) => (MOVEMENT_LABELS[m] || [m || '-'])[0];
export const statusLabel = (s) => (POSSESSION_STATUS[s] || [s || '-'])[0];

// Column definitions shared by on-screen tables and PDF/Excel exports.
export const SECTIONS = {
  possession: {
    title: 'Bikes in possession',
    columns: [
      ['bike_plate_number', 'Plate'], ['bike_golden_plate_number', 'Golden Plate'], ['rider_name', 'Rider'],
      ['handover_date', 'Handed over'], ['status', 'This month', statusLabel], ['swap_days', 'Swap days'],
    ],
  },
  handovers: {
    title: 'Handovers',
    columns: [
      ['handover_date', 'Date'], ['movement', 'Type', movementLabel], ['bike_plate_number', 'Plate'],
      ['rider_name', 'Rider'], ['location', 'Location'], ['odometer_km', 'ODO'],
    ],
  },
  takeovers: {
    title: 'Takeovers',
    columns: [
      ['takeover_date', 'Date'], ['movement', 'Type', movementLabel], ['takeover_type', 'Form type'],
      ['bike_plate_number', 'Plate'], ['rider_name', 'Rider'], ['odometer_km', 'ODO'], ['remark', 'Remark'],
    ],
  },
  fines: {
    title: 'Fines',
    amountKey: 'amount',
    columns: [
      ['fine_date', 'Date'], ['fine_number', 'Fine No.'], ['bike_plate_number', 'Plate'], ['rider_name', 'Rider'],
      ['reason', 'Reason'], ['amount', 'Amount', fmtMoney], ['admin_fees', 'Admin fee', fmtMoney], ['status', 'Status'],
    ],
  },
  salik: {
    title: 'SALIK',
    amountKey: 'total_amount',
    columns: [
      ['salik_date', 'Date'], ['salik_time', 'Time'], ['bike_plate_number', 'Plate'], ['rider_name', 'Rider'],
      ['gate_name', 'Gate'], ['total_amount', 'Total', fmtMoney], ['status', 'Status'],
    ],
  },
  maintenance: {
    title: 'Maintenance',
    amountKey: 'total_cost',
    columns: [
      ['maintenance_date', 'Date'], ['bike_plate_number', 'Plate'], ['rider_name', 'Rider'], ['type', 'Work'],
      ['items_count', 'Items'], ['total_cost', 'Cost', fmtMoney], ['status', 'Status'],
    ],
  },
};

export const monthRows = (m, key) => (key === 'possession' ? m.possession_motorcycles : m[key]) || [];

export const cellValue = (row, [key, , fmt]) => {
  const v = row[key];
  if (v === null || v === undefined || v === '') return '-';
  return fmt ? fmt(v) : v;
};

export const summaryHeader = ['Month', 'In possession', 'Start', '+ HO', '- TO', 'End', 'Swaps only', 'Fines', 'Fines AED', 'SALIK', 'SALIK AED', 'Maint.', 'Maint. AED'];

export const summaryRow = (m) => {
  const c = m.counts;
  return [m.month_label, c.possession ?? 0, c.opening_assigned, c.handovers, c.takeovers, c.motorcycles_assigned,
    c.possession_swap_only || 0, c.fines, c.fines_amount, c.salik, c.salik_amount, c.maintenance, c.maintenance_amount];
};

export const periodTotals = (months) => {
  const sum = (k) => months.reduce((a, m) => a + Number(m.counts[k] || 0), 0);
  const bikes = new Set();
  months.forEach((m) => (m.possession_motorcycles || []).forEach((b) => bikes.add(b.bike_plate_number || b.bike_id)));
  return {
    possession: bikes.size,
    opening: months[0]?.counts.opening_assigned ?? 0,
    handovers: sum('handovers'),
    takeovers: sum('takeovers'),
    closing: months[months.length - 1]?.counts.motorcycles_assigned ?? 0,
    swapOnlyMax: Math.max(0, ...months.map((m) => m.counts.possession_swap_only || 0)),
    fines: sum('fines'), finesAmount: sum('fines_amount'),
    salik: sum('salik'), salikAmount: sum('salik_amount'),
    maintenance: sum('maintenance'), maintenanceAmount: sum('maintenance_amount'),
  };
};
